import React from "react"; 
import { Link } from "react-router-dom";    
import RegionsListContent from "../../../components/Dashboard/RegionsListContent";

const RegionsList = () => {
  return (
    <>
      {/* Breadcrumb */}
      {/* <div className="breadcrumb-card">
        <h5>List of Regions</h5>

        <ul className="breadcrumb">
          <li>
            <Link to="/dashboard/ecommerce/">
              <i className="material-symbols-outlined">home</i>
              Dashboard
            </Link>
          </li>
          <li>Regions List</li>
        </ul>
      </div> */}

      <RegionsListContent />
    </>
  );
};

export default RegionsList;
